import React from "react";
import {MainCP}  from "../../../Components/modelo-confianza/modelo-confianza-v2/MainCP"

const ViewModeloConfianza: React.FC = () => <MainCP/>

export default ViewModeloConfianza;